import React from "react";
import { GlobalHotKeys, configure } from "react-hotkeys";

const SubmitCancelListener = ({
	enableOnTags,
	onSubmit,
	onCancel,
	submitDisabled = false,
	cancelDisabled = false
}) => {
	if (enableOnTags) {
		const defaultTags = ["input", "select", "textarea"];
		configure({
			ignoreTags: [...defaultTags.filter((tag) => !enableOnTags.includes(tag))]
		});
	}

	return (
		<GlobalHotKeys
			keyMap={{
				CANCEL: ["esc"],
				SUBMIT: ["enter"]
			}}
			handlers={{
				...(!onCancel || cancelDisabled ? {} : { CANCEL: onCancel }),
				...(!onSubmit || submitDisabled ? {} : { SUBMIT: onSubmit })
			}}
			allowChanges
		/>
	);
};

export default SubmitCancelListener;
